// extracted by mini-css-extract-plugin
export default {"order":"OrderContent_order__+0kAl","order__top":"OrderContent_order__top__09XH7","order__link":"OrderContent_order__link__gXcdP","order__title":"OrderContent_order__title__d32xG"};